import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import VideoPlayer from 'components/VideoPlayer'
import ProductCardInfo from './ProductCardInfo'
import { Expand } from '../Icons'

import {
  ProductCardWrapper,
  ProductCardImage,
  ProductCardInfoWrapper,
  CardModalButton,
  ProductCardVideoWrapper,
} from './ProductCard.style'

const ProductCard = ({
  brand,
  currency,
  description,
  image,
  richMedia,
  locale,
  rrpPrice,
  salePrice,
  villagePrice,
  villageLevelLabels,
  onclickProductModal,
  isCallout,
  villageSlug,
}) => {
  const [screenWidth, setScreenWidth] = useState(null)
  const containerRef = useRef(null)

  useEffect(() => {
    setScreenWidth(window.innerWidth)
    window.addEventListener('resize', () => setScreenWidth(window.innerWidth))
    return () => {
      window.removeEventListener('resize', () =>
        setScreenWidth(window.innerWidth)
      )
    }
  }, [])

  // Func that decides what type of media will be displayed in the product card image section
  const mediaToDisplay = () => {
    // If richMedia is present and it is a video then diaply that in VideoPlayer comp
    if (richMedia && richMedia.videoPortrait && richMedia.videoLandscape) {
      return (
        <ProductCardVideoWrapper width={containerRef?.current?.offsetWidth}>
          <VideoPlayer
            name={richMedia.name}
            controls={false}
            loop
            muted
            video={{
              portrait: richMedia.videoPortrait,
              landscape: richMedia.videoLandscape,
            }}
            autoplay
            image={image}
            videoMode="portrait"
            villageSlug={villageSlug}
          />
        </ProductCardVideoWrapper>
      )
    }

    // If richMedia is present (which takes priority over image) and it is a still image (not video) then display that
    if (richMedia && (richMedia.portrait || richMedia.landscape)) {
      return (
        <ProductCardImage
          image={
            richMedia.portrait.gatsbyImageData ||
            richMedia.landscape.gatsbyImageData
          }
          alt={richMedia.altText}
          width={containerRef?.current?.offsetWidth}
        />
      )
    }

    // If image is present display that
    if (image && (image.portrait || image.landscape)) {
      return (
        <ProductCardImage
          image={
            image.portrait.gatsbyImageData || image.landscape.gatsbyImageData
          }
          alt={image.altText}
          width={containerRef?.current?.offsetWidth}
        />
      )
    }

    // If video, richMedia or image are not available retun null explicity
    return null
  }

  return (
    <ProductCardWrapper
      onClick={onclickProductModal}
      isCallout={isCallout}
      ref={containerRef}>
      <CardModalButton>
        <Expand
          width={screenWidth > 600 ? 30 : 20}
          height={screenWidth > 600 ? 30 : 20}
        />
      </CardModalButton>
      {mediaToDisplay()}
      <ProductCardInfoWrapper>
        <ProductCardInfo
          {...{
            brand,
            currency,
            description,
            locale,
            rrpPrice,
            salePrice,
            villagePrice,
            labels: villageLevelLabels,
          }}
        />
      </ProductCardInfoWrapper>
    </ProductCardWrapper>
  )
}

ProductCard.propTypes = {
  brand: PropTypes.string.isRequired,
  currency: PropTypes.string,
  description: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.object]).isRequired,
  richMedia: PropTypes.oneOfType([PropTypes.object]).isRequired,
  locale: PropTypes.string,
  rrpPrice: PropTypes.number,
  salePrice: PropTypes.number,
  villagePrice: PropTypes.number,
  villageLevelLabels: PropTypes.shape({}),
  onclickProductModal: PropTypes.func,
  isCallout: PropTypes.bool,
  villageSlug: PropTypes.string,
}

ProductCard.defaultProps = {
  locale: 'en',
  salePrice: null,
  currency: null,
  rrpPrice: null,
  villagePrice: null,
  villageLevelLabels: {},
  onclickProductModal: () => {},
  isCallout: false,
  villageSlug: '',
}

export default ProductCard
